import styled from "styled-components"

export const HeaderContainer = styled.div` 
    background: #133654;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1000;
    position: relative;
    
    & .logo{
        height: 110px;
        width: 110px;
    }
    
    & .title{
        position: absolute;
        left: 50%;
        font-size: 24px;
        transform: translateX(-50%);
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
    }
    
    & .right{
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
        
        & .menu_btn{
            background: rgba(255,255,255,0.1);

            &:hover{
                background: #0f2a42;
                color: #FFFFFF;
            }
        }
        
        & .user{
            display: flex;
            align-items: center;
            justify-content: center;
            
            & .user_info{
                padding: 0 10px;
                
                & .name{
                    font-size: 14px;
                    font-weight: bold;
                }
                
                & .position{
                    font-size: 11px; 
                }
            }
        }
    }
    
    /* Mobile responsive styles */
    @media (max-width: 768px) {
        padding: 6px 8px !important;
        flex-wrap: nowrap !important;
        
        & .logo{
            height: 50px !important;
            width: 50px !important;
            flex-shrink: 0 !important;
        }
        
        & .title{
            position: static !important;
            transform: none !important;
            font-size: 13px !important;
            letter-spacing: 0.5px !important;
            white-space: nowrap !important;
            flex: 1 !important;
            text-align: center !important;
            margin: 0 8px !important;
        }
        
        & .right{
            gap: 6px !important;
            flex-shrink: 0 !important;
            
            & .user{
                & .user_info{
                    display: none !important; /* Hide user name/position on mobile */
                }
            }
            
            & button {
                font-size: 11px !important;
                padding: 6px 10px !important;
                height: auto !important;
                white-space: nowrap !important;
            }
        }
    }
    
    @media (max-width: 480px) {
        padding: 4px 6px;
        
        & .logo{
            height: 45px;
            width: 45px;
        }
        
        & .title{
            font-size: 11px;
            letter-spacing: 0.3px;
            margin: 0 4px;
        }
        
        & .right{
            gap: 4px;
            
            & button {
                font-size: 10px !important;
                padding: 5px 8px !important;
            }
        }
    }
    
    @media (max-width: 380px) {
        & .title{
            font-size: 10px;
            margin: 0 2px;
        }
        
        & .logo{
            height: 40px;
            width: 40px;
        }
        
        & .right{
            & button {
                font-size: 9px !important;
                padding: 4px 6px !important;
            }
        }
    }
`;